@use '@/styles/mixins' as *;

.region {
  position: fixed;
  left: 0;
  right: 0;
  top: calc(env(safe-area-inset-top) + #{$space-2});
  z-index: $z-toast;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $space-2;
  padding: 0 $space-3;
  pointer-events: none;

  @include tablet {
    top: calc(env(safe-area-inset-top) + #{$space-4});
  }
}

.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: $space-3;
  width: 100%;
  max-width: 460px;
  min-height: 56px;
  padding: $space-2 $space-2 $space-2 $space-3;
  border-radius: $radius-lg;
  background: var(--text);
  color: var(--bg);
  box-shadow: var(--shadow-3);
  animation: in $dur $ease-spring;
}

.icon {
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--bg) 16%, transparent);
}

.success .icon {
  background: var(--good);
  color: #fff;
}

.error .icon {
  background: var(--again);
  color: #fff;
}

.msg {
  flex: 1;
  font-size: 0.95rem;
  line-height: 1.35;
}

.action {
  min-height: 44px;
  padding: 0 $space-4;
  border-radius: 999px;
  font-weight: 700;
  background: var(--bg);
  color: var(--text);
  @include pressable;
  @include focus-ring;
}

.x {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  opacity: 0.7;
}

@keyframes in {
  from {
    opacity: 0;
    transform: translateY(-12px) scale(0.96);
  }
}
